import { render, staticRenderFns } from "./SettingDisciplinary.vue?vue&type=template&id=41bf0b07&"
import script from "./SettingDisciplinary.vue?vue&type=script&lang=js&"
export * from "./SettingDisciplinary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports